import { useMemo } from "react";
import { IdwTable } from "../../../../../../common/idw-table/idw-table";
import { resources } from "@constants/hardcoded-strings";
import { IdwTableContainer } from "../../../../../../common/idw-table-container/idw-table-container";
import { FormattedVerificationTransactionDetailsAssertionScoreModifier } from "@idw-types/data/verification-transaction-details";
import styles from "./assertion-score-details-table-container.less";
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from "@tanstack/react-table";

type AssertionScoreDetailsTableContainerProps = {
    assertionScoreModifiers: Array<FormattedVerificationTransactionDetailsAssertionScoreModifier>;
};

type AssertionScoreModifierTableDataRow = FormattedVerificationTransactionDetailsAssertionScoreModifier & {
    assertionName: string;
    serviceOfferingName: string;
    points: string;
}

//todo - finish
export const AssertionScoreDetailsTableContainer = (props: AssertionScoreDetailsTableContainerProps) => {
    const { assertionScoreModifiers } = props;

    const assertionScoreModifierTableData: Array<AssertionScoreModifierTableDataRow> = useMemo(() => {
        return assertionScoreModifiers.map(assertionScoreModifier => ({
            ...assertionScoreModifier,
            assertionName: assertionScoreModifier.assertion?.shortName || "",
            serviceOfferingName: assertionScoreModifier.serviceOffering?.name || "",
            points: `${assertionScoreModifier.claimAssertionScore} / ${assertionScoreModifier.maxPotentialScore}`
        }))
    }, [assertionScoreModifiers]);

    const columnHelper = createColumnHelper<AssertionScoreModifierTableDataRow>();
    const columns = useMemo(() => ([
        columnHelper.accessor("assertionName", {
            header: resources.tables.assertionScoreDetails.columns.assertion.header
        }),
        columnHelper.accessor("serviceOfferingName", {
            header: resources.tables.assertionScoreDetails.columns.serviceOffering.header
        }),
        columnHelper.accessor("claimStatus", {
            header: resources.tables.assertionScoreDetails.columns.status.header
        }),
        columnHelper.accessor("points", {
            header: resources.tables.assertionScoreDetails.columns.points.header
        })
    ]), [assertionScoreModifierTableData]);

    const useTableResult = useReactTable({
        columns,
        data: assertionScoreModifierTableData,
        filterFns: null,
        enableFilters: false,
        sortDescFirst: false,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel()
    });

    return (
        <IdwTableContainer className={styles.assertionScoreDetailsTableContainer}>
            <IdwTable
                id="assertion-score-details"
                useTableResult={useTableResult}
                headerColumnKeyPrefix={"assertion-score-details"}
            />
        </IdwTableContainer>
    );
};